import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/Navbar";

const KEYS = ["privacy", "terms", "community", "contacts"];

// Rende cliccabili i token noti (dominio IPS + email di assistenza) in tutte le pagine legali.
// Il resto resta testo invariato, senza dangerouslySetInnerHTML.
function renderText(text) {
  const re = /(www\.ips-benefit\.org|support@youpam\.com)/g;
  return text.split(re).map((p, i) => {
    if (p === "www.ips-benefit.org")
      return <a key={i} href="https://www.ips-benefit.org" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline" data-testid="legal-ips-link">www.ips-benefit.org</a>;
    if (p === "support@youpam.com")
      return <a key={i} href="mailto:support@youpam.com" className="text-blue-600 underline" data-testid="legal-support-mail">support@youpam.com</a>;
    return p;
  });
}

// Una riga è un titolo di sezione se è numerata ("1. ...") oppure breve, senza punti, ":" o "@".
function isHeading(line) {
  const l = line.trim();
  if (/^\d+\.\s/.test(l)) return true;
  if (l.length > 0 && l.length <= 48 && !l.includes(".") && !l.includes(":") && !l.includes("@")) return true;
  return false;
}

export default function Legal() {
  const { doc } = useParams();
  const { t } = useTranslation();
  const key = KEYS.includes(doc) ? doc : "terms";
  const paragraphs = t(`legalpages.${key}_b`).split("\n").filter((p) => p.trim().length);
  return (<Layout><div className="yp-container max-w-3xl py-10">
    <h1 className="text-3xl font-bold mb-6">{t(`legalpages.${key}_t`)}</h1>
    <div className="yp-card p-6 text-slate-700 text-sm leading-relaxed" data-testid={`legal-${key}`}>
      {paragraphs.map((para, i) =>
        isHeading(para)
          ? <h2 key={i} className={`font-semibold text-slate-900 text-base ${i > 0 ? "mt-6" : ""} mb-1`}>{renderText(para)}</h2>
          : <p key={i} className="mt-2">{renderText(para)}</p>
      )}
    </div>
  </div></Layout>);
}
